require("core-js/modules/es6.regexp.split");

var isBlank = require('./isBlank');

var trim = require('./trim');

module.exports = function words(str, delimiter) {
  if (isBlank(str)) return [];
  return trim(str, delimiter).split(delimiter || /\s+/);
};